/** Bound optional translation downloads; empty or malformed responses are failures. */
export async function loadTranslationResources(url: string) {
  const response = await fetch(url, {
    cache: "no-store",
    signal: AbortSignal.timeout(5000),
  });
  if (!response.ok) throw new Error(`Translation HTTP ${response.status}`);
  const resources: unknown = await response.json();
  if (!resources || typeof resources !== "object" || Array.isArray(resources))
    throw new Error("Invalid translation resources");
  return resources as Record<string, unknown>;
}
